exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enote-content .enote-container[data-v-4b6518f4]{margin-bottom:0.10417rem}.enote-content .enote-container .enote-item-text span[data-v-4b6518f4]{display:inline-block;padding:0.03125rem 0.05208rem;border-radius:0.02083rem;background-color:#f6f6f6;font-weight:700}.enote-content .enote-container .enote-item-image[data-v-4b6518f4]{width:0.78125rem;height:0.78125rem;background-color:#f6f6f6}.enote-content .enote-container .enote-item-image[data-v-4b6518f4] img{width:0.78125rem;height:0.78125rem}.enote-content-noData[data-v-4b6518f4]{height:0.52083rem;display:flex;align-items:center;justify-content:center}\n", ""]);

// exports
